import React, {Component} from "react";
import {Link} from "react-router-dom";
import {observer} from "mobx-react";
import {mesAutobind} from "@posco/posco-shared";


// 로컬로 진행하는경우 작업 편의를 위해 url을 개발서버와 동일하게 변경 필요.
const localpath = location.host.includes("localhost") ? "/o10t01-front/" : "";
// 실제 url은 짧게 출력하기 위한 정규식.
const customRegExp = /^\/common\/[^\/\s]+\/(inner\/)?/g;
// 쿼리스트링 비교제외를 위한 정규식
const customRegExp2 = /(\?([^#\s]*))/g;

@mesAutobind
@observer
class ToptabComponent extends Component {
  constructor(props) {
    super(props);
    this.topTabRef = React.createRef();
    this.topTabInRef = React.createRef();
    this.tabDropdown = React.createRef();
  }

  state = {
    topTabOnoff: true,
    topTabCon: false
  };

  componentDidMount() {
    this.resizeTimer = setTimeout(() => {
      this.tabResize();
      clearTimeout(this.resizeTimer);
    }, 200);
    window.addEventListener("resize", this.tabResize);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {

//활성화 탭 리스트 변경시 기능
    if (prevProps.topTabList !== this.props.topTabList) {
      if (!this.props.topTabList.length) return;
      setTimeout(() => {
        this.topTabAutoScroll();
        this.tabResize();
      }, 10);
    }
    // 메뉴확장될때, 탭 항목 늘어나거나 줄어들때 추가필요
    if (prevProps.navState !== this.props.navState) {
      setTimeout(() => {
        this.tabResize();
      }, 200);
    }
  }


  componentWillUnmount() {
    clearTimeout(this.resizeTimer);
    window.removeEventListener("resize", this.tabResize);
  }

  //----------------------------------------------------------------------------------

  topTabToggle() {
    this.setState({topTabOnoff: !this.state.topTabOnoff});
  }

  //탭버튼 선택 기능
  tapping(props) {
    const pattMenuId = props.target.parentElement.getAttribute("pattmenuid");
    const tmp = this.props.topTabList.map(props => {
      props.pattMenuId === pattMenuId ? props.active = true : props.active = false;
      return props;
    });

    this.props.topTabListSet(tmp);
  }

  //탭닫기 기능
  closing(props) {
    if (this.props.topTabList.length <= 1) return console.log("마지막 탭");
    const pattMenuId = props.target.parentElement.getAttribute("pattmenuid");
    const tmp = this.props.topTabList.filter((props) => props.pattMenuId !== pattMenuId);
    //지금 보고있는 페이지를 닫은 거면
    if (!tmp.filter(item => item.active === true).length) {
      //마지막 페이지를 활성화
      tmp.forEach((props, index) => {
        index === tmp.length - 1 ? props.active = true : props.active = false;
      });
      //활성화된 마지막 페이지 히스토리 푸쉬
      this.props.history.push(tmp[tmp.length - 1].pgmUrl);
    }
    this.props.topTabListSet([...tmp]);
  }

  // 탭 controller
  topTabWheel(e) {
    const data = e.deltaY;
    const scrollX = this.topTabRef.current.scrollLeft + data;
    this.topTabRef.current.scrollLeft = scrollX;
  }

  topTabClickLeft() {
    const scrollX = this.topTabRef.current.scrollLeft - 100;
    this.topTabRef.current.scrollLeft = scrollX;
  }

  topTabClickRight() {
    const scrollX = this.topTabRef.current.scrollLeft + 100;
    this.topTabRef.current.scrollLeft = scrollX;
  }

  topTabAutoScroll() {
    const scrollX = document.querySelector("div.topTabArea li.active").offsetLeft;
    this.topTabRef.current.scrollLeft = scrollX - 40;
  }

  //탭 컨트롤러 onOff
  tabResize() {
    const wrapWidth = this.topTabRef.current.offsetWidth,
      innerWidth = this.topTabInRef.current.offsetWidth;
    if (wrapWidth <= innerWidth) {
      this.topTabConSet(true);
    } else {
      this.topTabConSet(false);
    }
  }

  topTabConSet(value) {
    this.setState({topTabCon: value});
  }

  render() {

    const {children, navState} = this.props;
    const {topTabCon, topTabOnoff} = this.state;

    return (
      <>
        <div className={
          `${navState === "open"
            ? "tabArea close"
            : navState === "close"
              ? "tabArea open"
              : navState === "last"
                ? "tabArea"
                : "tabArea"
          }
          ${
            !topTabOnoff
              ? "tabClose"
              : ""
          }
        `}>

          {/* 상단 탭 부분 */}
          <div className={!topTabOnoff ? "topTabToggleBtn" : "topTabToggleBtn downarrow"}
               onClick={this.topTabToggle}/>
          <div className={!topTabOnoff ? "topTabArea" : "topTabArea dropdown"} onWheel={this.topTabWheel}
               ref={this.topTabRef}>
            <ul ref={this.topTabInRef} onClick={this.topTabAutoScroll}>
              {/* ---- begin :: tabList ---- */}
              {this.props.topTabList.map(props =>
                <li className={props.active === true ? "active" : ""} key={"tab" + props.pattMenuId}
                    pattmenuid={props.pattMenuId}>
                  {/*사업메뉴는 즐겨찾기 없음*/}
                  {this.props.projectNumber ? null :
                    <>
                      {
                        //해당 pattMenuId와 의 favorMenuList의 pattMenuId가 같은게 있으면 true
                        this.props.favorMenuList.filter(item => item.pattMenuId === props.pattMenuId).length ?
                          <button className={"tabBookmark marking"}
                                  onClick={() => this.props.deleteFavorMenuList(props.pattMenuId)}
                                  style={{cursor: "pointer"}}
                          >북마크true</button>
                          :
                          <button className={"tabBookmark"}
                                  onClick={() => this.props.addFavorMenuList(props.pattMenuId)}
                                  style={{cursor: "pointer"}}
                          >북마크false</button>
                      }
                    </>
                  }
                  <Link to={props.pgmUrl || ""} onClick={this.tapping}>{props.menuNm}</Link>
                  {this.props.topTabList.length > 1 &&
                    <button onClick={this.closing} className="tabClose">닫기</button>
                  }
                </li>
              )}
              {/* ---- end :: tabList ---- */}
            </ul>
            <div
              className={
                topTabCon === false
                  ? "tabCon off"
                  : !topTabOnoff
                    ? "tabCon on op0"
                    : "tabCon on"
              }
            >
              <button onClick={this.topTabClickLeft}>◀</button>
              <button onClick={this.topTabClickRight}>▶</button>
              <input id="tabExpo" type="checkbox"/>
              <label htmlFor="tabExpo">▤</label>
              <ul onWheel={event => event.stopPropagation()} onClick={this.topTabAutoScroll}>
                {/* ---- begin :: tabExpoList ---- */}
                {this.props.topTabList.map(props =>
                  <li className={props.active === true ? "active" : ""} key={"tabExpo" + props.pattMenuId}
                      pattmenuid={props.pattMenuId}>
                    <Link to={props.pgmUrl || ""} onClick={this.tapping}
                          style={{whiteSpace: "pre"}}>{props.menuNm}</Link>
                    <button onClick={this.closing} className="tabClose">닫기</button>
                  </li>
                )}
                {/* ---- end :: tabExpoList ---- */}
              </ul>
            </div>
          </div>
          {children}
        </div>
      </>

    );
  }
}

export default ToptabComponent;
